import { Routes } from '@angular/router';
import { RegistrationChangePasswordComponent } from './landing/base/registration/registration-change-password/registration-change-password.component';
import { RestorePasswordComponent } from './pages/catalog/settings-page/restore-password/restore-password.component';
import { AuthRoleGuard } from '@profilum-library';
import { loadRemote } from '@module-federation/enhanced/runtime';
import { UserRoles } from '@frontend/profilum-components';
import { UserProfileComponent } from './pages/catalog/user-profile-page/user-profile.component';
import { LayoutComponent } from './new-design/layout/layout.component';
import { ParentPanelComponent } from './pages/control-panel/parent/parent-panel.component';

export const routeConfig: Routes = [
  { path: 'change_password', component: RegistrationChangePasswordComponent },
  { path: 'recovery_password', component: RestorePasswordComponent },
  { path: 'eljur-login', loadComponent: () => import('./new-design/eljur-login/eljur-login.component').then(m => m.EljurLoginComponent) },
  {
    path: 'classes',
    component: LayoutComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Teacher, UserRoles.SchoolAdmin] },
    children: [
      {
        path: '',
        loadComponent: () => loadRemote('pflm_b2gnew/Classes'),
      },
      {
        path: 'class-view',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'class-view/:id',
        loadComponent: () => loadRemote('pflm_b2gnew/ClassViewComponent'),
      },
      {
        path: 'archive-classes',
        loadComponent: () => loadRemote('pflm_b2gnew/ArchiveClassesComponent'),
      },
      {
        path: 'all-teachers',
        loadComponent: () => loadRemote('pflm_b2gnew/TeachersComponent'),
      },
      {
        path: 'all-pupils',
        loadComponent: () => loadRemote('pflm_b2gnew/AllPupilsComponent'),
      },
    ],
  },
  {
    path: 'statistics',
    component: LayoutComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Teacher, UserRoles.SchoolAdmin] },
    children: [
      {
        path: '',
        loadComponent: () => loadRemote('pflm_b2gnew/StatisticsComponent'),
      },
      {
        path: 'class-statistics',
        redirectTo: 'statistics',
        pathMatch: 'full',
      },
      {
        path: 'class-statistics/:id',
        loadComponent: () => loadRemote('pflm_b2gnew/ClassStatisticsComponent'),
      },
    ],
  },
  {
    path: 'materials',
    component: LayoutComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Teacher] },
    children: [
      {
        path: '',
        loadComponent: () => loadRemote('pflm_b2gnew/TeacherStartPageComponent'),
      },
      {
        path: 'teacher-lessons',
        redirectTo: 'materials',
        pathMatch: 'full',
      },
      {
        path: 'teacher-lessons/:classId',
        loadComponent: () => loadRemote('pflm_b2gnew/TeacherLessonsComponent'),
      },
    ],
  },
  {
    path: 'parentmain',
    component: ParentPanelComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: ['parent'] },
    children: [],
  },
  {
    path: 'professions',
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil, UserRoles.Parent, UserRoles.Teacher, UserRoles.SchoolAdmin] },
    children: [
      {
        path: '**',
        loadComponent: () => import('./new-design/professions-new/professions-new.component').then(m => m.ProfessionsNewComponent),
      },
    ],
  },
  {
    path: 'profession/:hrid',
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil, UserRoles.Parent, UserRoles.Teacher, UserRoles.SchoolAdmin] },
    children: [
      {
        path: '**',
        loadComponent: () => import('./new-design/professions-new/professions-new.component').then(m => m.ProfessionsNewComponent),
      },
    ],
  },
  {
    path: 'discover-professions/:sessionId',
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil] },
    children: [
      {
        path: '**',
        loadComponent: () =>
          import('./new-design/discover-professions/discover-professions.component').then(
            m => m.DiscoverProfessionsComponent
          ),
      },
    ],
  },
  {
    path: 'profile',
    component: UserProfileComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil, UserRoles.Parent, UserRoles.Teacher, UserRoles.SchoolAdmin] },
  },
  {
    path: 'lessons',
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil] },
    children: [
      {
        path: '',
        loadComponent: () => import('./new-design/lessons/lessons.component').then(m => m.LessonsComponent),
      },
    ],
  },
  {
    path: 'results',
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil] },
    children: [
      {
        path: '**',
        loadComponent: () => import('./new-design/results/results.component').then(m => m.ResultsComponent),
      },
    ],
  },
  {
    path: 'survey',
    canActivate: [AuthRoleGuard],
    data: { roles: [UserRoles.Pupil] },
    children: [
      {
        path: '**',
        loadComponent: () => import('./new-design/survey/survey.component').then(m => m.SurveyComponent),
      },
    ],
  },
  { path: 'error', loadComponent: () => import('./new-design/survey-error/survey-error.component').then(m => m.SurveyErrorComponent) },
  { path: '500', loadComponent: () => import('./new-design/page-500/page-500.component').then(m => m.Page500Component) },
  { path: '404', loadComponent: () => import('./new-design/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent) },
  { path: '**', redirectTo: '/404' },

  /* {
    path: 'professions',
    component: ProfessionCardsComponent,
    data: { roles: ['pupil', 'parent', 'tutor'] },
  },
  {
    path: 'professions-mobile',
    loadChildren: () => import('app/pages/catalog/profession-mobile-page/professions-mobile.module').then(m => m.ProfessionsMobileModule),
  },
  {
    path: 'professions-mobile/:filter',
    component: ProfessionMobileCatalogComponent,
    data: { roles: ['pupil'] },
  },
  {
    path: 'professions/:hrid',
    component: ProfessionDetailsComponent,
    data: { roles: ['pupil', 'parent', 'director'] },
  },
  {
    path: 'profession/:hrid',
    component: ProfessionDetailMobileComponent,
    data: { roles: ['pupil'] },
  },
  {
    path: 'portfolio',
    component: PortfolioPageComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: ['pupil'] },
  },
  {
    path: 'profile',
    component: UserProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pupil-profile',
    loadChildren: () => import('app/pages/catalog/pupil-mobile-profile/pupil-mobile-profile.module').then(m => m.PupilMobileProfileModule),
  },
  {
    path: 'pupil-edit-profile',
    component: PupilMobileEditProfileComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: ['pupil'] },
  },
  {
    path: 'pupil-edit-photo',
    component: PupilMobileEditUserAvatarComponent,
    canActivate: [AuthRoleGuard],
    data: { roles: ['pupil'] },
  },
  { path: '500', component: Page500Component },
  { path: '404', component: Page404Component },
  { path: '**', redirectTo: '/404' }*/
];
